<template>
  <div>
  
    <article 
      v-if="!loading && projectInventory.length == 0" 
      class="message is-info is-fullwidth">
      <div class="message-body">
        There is no inventory.
      </div>
    </article>

    <table v-else class="table is-fullwidth is-hoverable has-small-font">

      <thead>
        <tr>
          <th 
            v-for="(header, headerIndex) in headers"
            :key="headerIndex">
            {{ header }}
          </th>
        </tr>
      </thead>

      <tbody>
        <template 
          v-for="inventoryItem in projectInventory">
          <tr
            class="v-centered"
            :key="inventoryItem.id">

            <td>
              {{ inventoryItem.project.project_name }}
            </td>
            <td>
              {{ inventoryItem.inventory.product_master.product_category.category }}
            </td>         
            <td>
              {{ inventoryItem.inventory.product_master.name }}
            </td>
            <td class="text--nowrap">
              <template v-if="inventoryItem.inventory.product_master.product_category.has_dimensions">
                {{ lwt(inventoryItem.inventory.stocking_unit) }}
              </template>
              <span>
                {{ inventoryItem.inventory.product_master.size }}
              </span>
            </td>
            <td>
              {{ inventoryItem.qty_needed }}
            </td>
            <td>
              {{ inventoryItem.qty_available }}
            </td>
            <td>
              {{ inventoryItem.value_available | currency }}
            </td>
            <td>
              {{ inventoryItem.avg_price_unit | currency }}
            </td>

            <td>
              <div class="buttons buttons-right">
                <button 
                  @click.stop="modifyItem(inventoryItem, 'adjust')"
                  class="button has-text-grey is-small">
                  <span class="icon">
                    <i class="fas fa-sliders-h"></i>
                  </span>
                  <span>Adjust</span>
                </button>
                <button 
                  @click.stop="modifyItem(inventoryItem, 'release')"
                  class="button has-text-grey is-small">
                  <span class="icon">
                    <i class="fas fa-minus-circle"></i>
                  </span>
                  <span>Release</span>
                </button>
                <button 
                  @click.stop="modifyItem(inventoryItem, 'transfer')"
                  class="button has-text-grey is-small">
                  <span class="icon">
                    <i class="fas fa-exchange-alt"></i>
                  </span>
                  <span>Transfer</span>
                </button>
                <button 
                  @click.stop="modifyItem(inventoryItem, 'transform')"
                  class="button has-text-grey is-small">
                  <span class="icon">
                    <i class="fas fa-random"></i>
                  </span>
                  <span>Transform</span>
                </button>
              </div>
            </td>

          </tr>
        </template>
      </tbody>

    </table>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <adjust-project-inventory-modal
      v-if="modifyingItem"
      v-model="modifyingAction.adjust"
      :project-inventory="modifyingItem"/>

    <release-project-inventory-modal
      v-if="modifyingItem"
      v-model="modifyingAction.release"
      :project-inventory="modifyingItem"/>

    <transfer-project-to-project-modal
      v-if="modifyingItem"
      v-model="modifyingAction.transfer"
      :project-inventory="modifyingItem"/>

    <transform-inventory-modal 
      v-if="modifyingItem"
      v-model="modifyingAction.transform"
      :project-inventory="modifyingItem"/>
      
  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import AdjustProjectInventoryModal from '@/components/inventory/AdjustProjectInventoryModal'
import ReleaseProjectInventoryModal from '@/components/inventory/ReleaseProjectInventoryModal'
import TransferProjectToProjectModal from '@/components/inventory/TransferProjectToProjectModal'
import TransformInventoryModal from '@/components/inventory/TransformInventoryModal'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    VPagination, AdjustProjectInventoryModal,
    ReleaseProjectInventoryModal,
    TransferProjectToProjectModal, TransformInventoryModal
  },
  data() {
    return {
      headers: [
        'Project', 'Product Category', 'Product Name',
        'Product Size', 'Quantity Needed', 'Quantity Available', 
        'Value', 'Avg. Price/Unit', ''
      ],
      locationHeaders: [
        'Warehouse', 'Warehouse Code', 'Warehouse Location', 
        'Warehouse Location Code', 'Quantity Stored', ''
      ],
      modifyingItem: null,
      modifyingAction: {
        adjust: false,
        release: false,
        transfer: false,
        transform: false
      }
    }
  },
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("inventoryProject", [
      "projectInventory", "pagination", "selected", "loading", "allSelected"
    ])
  },
  watch: {
    'pagination.page'() {
      this.getInventory(this.pagination);
    }
  },
  methods: {
    ...mapActions("inventoryProject", [
      "getInventory", "adjustInventory", "toggleAllSelected"
    ]),
    ...mapMutations("inventory", ["changePage", "toggleSelected"]),
    initialize() {
      this.getInventory();
    },
    modifyItem(item, action) {
      this.modifyingItem = item;
      this.modifyingAction[action] = true;
    },
    lwt(product) {
      if (product) {
        return `L${product.length_in_str}" x W${product.width_in_str}" x T${product.thick_in_str}"`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>